import AdvancedPage from './advancedPage';
export default AdvancedPage;
